import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {getAreaStatistics} from '@apis'
import Chart from '@components/chart'
import ChartBlock from '@components/chartBlock'

const EnergyConsumption = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo
    const [energyConsumptionChartData, setEnergyConsumptionChartData] = useState([])

    async function queryAreaStatistic() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
        dimension: 3,
      }
      const res = await getAreaStatistics(params)
      if (res && res.data) {
        const total = res.data.reduce((all, currentValue) => {
          return currentValue.energy + all
        }, 0)
        const energyArr = res.data.map(item => {
          const dataObj = {
            areaName: item.areaName,
            count: item.energy,
            percent: total ? item.energy / total : 0
          }
          return dataObj
        })
        setEnergyConsumptionChartData(energyArr)
      }
    }

    useEffect(() => {
      queryAreaStatistic()
    }, [])

    const renderEnergyChart = (instance, opts) => {
      const totalData = opts.data.reduce((total, curValue) => total + curValue.count, 0)
      instance.data(opts.data);
      instance.scale('percent', {
        formatter: (val) => {
          val = val * 100 + '%';
          return val;
        },
      });
      instance.coordinate('theta', {
        radius: 1,
        innerRadius: 0.7,
      });
      instance.tooltip({
        showTitle: false,
        showMarkers: false,
        itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{areaName}: {value}</li>',
      });
      // 辅助文本
      instance
        .annotation()
        .text({
          position: ['50%', '50%'],
          content: '区域能耗',
          style: {
            fontSize: 20,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: -20,
        })
        .text({
          position: ['50%', '50%'],
          content: totalData.toFixed(2),
          style: {
            fontSize: 20,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetX: 0,
          offsetY: 20,
        })
        // .text({
        //   position: ['50%', '50%'],
        //   content: '台',
        //   style: {
        //     fontSize: 14,
        //     fill: '#8c8c8c',
        //     textAlign: 'center',
        //   },
        //   offsetY: 20,
        //   offsetX: 20,
        // });
      instance
        .interval()
        .adjust('stack')
        .position('percent')
        .color('areaName')
        .label('percent', (percent) => {
          return {
            content: (data) => {
              return `${data.areaName}: ${(percent * 100).toFixed(2)}%`
            },
            style: {
              fill: '#fff',
              fontSize: 14
            }
          };
        })
        .tooltip('areaName*count*percent', (areaName, count, percent) => {
          percent = (percent * 100).toFixed(2) + '%'
          return {
            areaName,
            name: count,
            value: percent,
          };
        });
        
      instance.legend({
        position: 'left',
        itemName: {
          style: {
            fontSize: 16,
            fill: '#fff'
          }
        }
      })

      instance.interaction('element-active');
      
      // instance.theme({ 
      //   "styleSheet": { 
      //     "brandColor": "#FF6B3B", 
      //     "paletteQualitative10": 
      //       [
      //         "#FF6B3B", 
      //         "#626681", 
      //         "#FFC100", 
      //         "#9FB40F", 
      //         "#76523B", 
      //         "#DAD5B5", 
      //         "#0E8E89", 
      //         "#E19348", 
      //         "#F383A2", 
      //         "#247FEA"
      //       ], 
      //     "paletteQualitative20": 
      //       [
      //         "#FF6B3B", 
      //         "#626681", 
      //         "#FFC100",
      //         "#9FB40F",
      //         "#76523B",
      //         "#DAD5B5",
      //         "#0E8E89",
      //         "#E19348",
      //         "#F383A2",
      //         "#247FEA",
      //         "#2BCB95",
      //         "#B1ABF4",
      //         "#1D42C2",
      //         "#1D9ED1",
      //         "#D64BC0",
      //         "#255634",
      //         "#8C8C47",
      //         "#8CDAE5",
      //         "#8E283B",
      //         "#791DC9"
      //       ] 
      //   } 
      // });

      instance.render();
    }
    return (
      <ChartBlock
        title="区域能耗占比"
      >
        {
          energyConsumptionChartData.length ? (
            <Chart renderChart={renderEnergyChart} style={{height: 220}} padding={25} data={energyConsumptionChartData} />
          ) : null
        }
      </ChartBlock>
    )
  })
)

export default EnergyConsumption
